var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27272 2H12.6727C13.3727 2 13.9454 2.57272 13.9454 3.27272V4.67271C13.9454 5.1818 13.6272 5.81816 13.309 6.13634L10.5727 8.55451C10.1909 8.87269 9.93633 9.50905 9.93633 10.0181V12.7545C9.93633 13.1363 9.68178 13.6454 9.3636 13.8363L8.4727 14.409C7.64543 14.9181 6.49998 14.3454 6.49998 13.3272V9.9545C6.49998 9.50905 6.24544 8.93633 5.99089 8.61815L3.57272 6.07271C3.25454 5.75453 3 5.1818 3 4.79999V3.33636C3 2.57272 3.57272 2 4.27272 2Z",
    stroke: "#004EFF",
    strokeWidth: 0.95454,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79155 2L4.6543 7.02725",
    stroke: "#004EFF",
    strokeWidth: 0.95454,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.1e5b3a1c57a05550e1cc99875d30f49f.svg";
export { ForwardRef as ReactComponent };